import React from "react";

function LinkIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <g clipPath="url(#7igvdogcaa)">
        <path
          fill="#333"
          d="M0 .642v14.72a.64.64 0 00.642.643h14.72a.64.64 0 00.643-.642V8.164c0-.09-.07-.159-.16-.159h-1.12a.158.158 0 00-.159.16v6.401H1.44V1.44h6.4c.09 0 .159-.07.159-.16V.16A.157.157 0 007.84 0H.643A.637.637 0 000 .642zm12.226 1.882l-1.369-1.369a.126.126 0 01.075-.214l4.515-.528c.08-.01.15.06.14.14l-.528 4.515a.126.126 0 01-.214.075l-1.359-1.36a.12.12 0 00-.174 0L5.65 11.44a.12.12 0 01-.174 0l-.901-.901a.12.12 0 010-.174l7.661-7.662a.12.12 0 000-.174l-.01-.005z"
        ></path>
      </g>
      <defs>
        <clipPath id="7igvdogcaa">
          <path fill="#fff" d="M0 0h16v16H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default LinkIcon;
